/**
 * SectionHeader Component
 * Reusable header for landing page sections with title, subtitle, and optional description
 */

import React from 'react';
import { clsx } from 'clsx';

export interface SectionHeaderProps {
  title: string;
  subtitle?: string;
  description?: string;
  align?: 'left' | 'center';
  className?: string;
}

export const SectionHeader: React.FC<SectionHeaderProps> = ({
  title,
  subtitle,
  description,
  align = 'center',
  className,
}) => {
  const alignmentStyles = {
    left: 'text-left',
    center: 'text-center mx-auto',
  };

  return (
    <div className={clsx('max-w-3xl mb-12 md:mb-16', alignmentStyles[align], className)}>
      {subtitle && (
        <p className="text-primary-500 font-semibold mb-3 uppercase tracking-wide text-sm">
          {subtitle}
        </p>
      )}
      <h2 className="font-display text-4xl md:text-5xl text-ink mb-4">
        {title}
      </h2>
      {description && (
        <p className="text-lg md:text-xl text-ink-muted leading-relaxed">
          {description}
        </p>
      )}
    </div>
  );
};
